"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
var _toConsumableArray2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.find-index");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var notification = _interopRequireWildcard(require("@/api/notification"));
var store = _interopRequireWildcard(require("@/api/store"));
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Tinymce: _Tinymce.default
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(["token"])), (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  created: function created() {
    this.fetchStore();
  },
  data: function data() {
    return {
      dialogVisible: false,
      stores: [],
      submitLoading: false,
      dialogStatus: "create",
      baseUrl: process.env.VUE_APP_BASE_API,
      baseUrlMedia: process.env.VUE_APP_BASE_URL_MEDIA,
      formData: {},
      rules: {
        title: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập tiêu đề"
        },
        content: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập nội dung"
        },
        shortDescription: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nhập nội dung"
        },
        areaId: {
          required: true,
          trigger: "submit",
          message: "Vui lòng chọn khu vực"
        }
      }
    };
  },
  methods: {
    beforeUpload: function beforeUpload(file) {
      this.dialogLoading = true;
      var isJPG = file.type.includes("image");
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.dialogLoading = false;
        this.$message.error("Chỉ chấp nhận ảnh dưới 2MB");
      }
      if (!isJPG) {
        this.dialogLoading = false;
        this.$message.error("Ảnh không đúng định dạng!");
      }
      return isJPG && isLt2M;
    },
    handleCreate: function handleCreate() {
      var _this = this;
      this.dialogVisible = true;
      this.dialogStatus = "create";
      this.formData = {};
      this.$nextTick(function () {
        _this.$refs["form"].clearValidate();
        if (_this.$store.state.user.info.area) {
          _this.$set(_this.formData, "areaId", _this.$store.state.user.info.area.id);
        }
      });
      setTimeout(function () {
        _this.fetchStore();
      });
    },
    handleUploadSuccess: function handleUploadSuccess(res, file) {
      this.$set(this.formData, "thumbnail", res.data.path);
      this.dialogLoading = false;
    },
    handleUpdate: function handleUpdate(data) {
      var _this2 = this;
      this.dialogVisible = true;
      this.dialogStatus = "update";
      this.$nextTick(function () {
        _this2.$refs["form"].clearValidate();
        _this2.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
          areaId: data.area && data.area.id,
          storeId: data.store && data.store.id
        });
        if (_this2.$store.state.user.info.area) {
          _this2.$set(_this2.formData, "areaId", _this2.$store.state.user.info.area.id);
        }
        _this2.$refs["editor"].setContent(_this2.formData.content);
      });
      setTimeout( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var findIndex;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.fetchStore();
            case 2:
              if (data.store) {
                findIndex = _this2.stores.findIndex(function (item) {
                  return item.id == data.store.id;
                });
                if (findIndex == -1) {
                  _this2.stores = [].concat((0, _toConsumableArray2.default)(_this2.stores), [data.store]);
                }
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    },
    createData: function createData() {
      var _this3 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this3.submitLoading = true;
          var data = {
            notification: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.formData), {}, {
              target: "CUSTOMER"
            }),
            newsId: _this3.formData.newsId,
            areaId: _this3.formData.areaId,
            storeId: _this3.formData.storeId
          };
          notification.create(data).then(function (res) {
            if (res.status) {
              _this3.$message({
                type: "success",
                message: "Thêm mới thành công"
              });
              _this3.$emit("create:success");
              _this3.dialogVisible = false;
            }
          }).finally(function () {
            _this3.submitLoading = false;
          });
        }
      });
    },
    fetchStore: function () {
      var _fetchStore = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var search,
          areaId,
          res,
          _args2 = arguments;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              search = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "";
              areaId = this.formData.areaId ? this.formData.areaId : this.$store.state.user.info.area ? this.$store.state.user.info.area.id : undefined;
              if (areaId) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", this.stores = []);
            case 4:
              _context2.next = 6;
              return store.findAll({
                limit: 50,
                page: 1,
                search: search,
                areaId: areaId
              });
            case 6:
              res = _context2.sent;
              this.stores = res.data.data;
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchStore() {
        return _fetchStore.apply(this, arguments);
      }
      return fetchStore;
    }(),
    onChangeArea: function onChangeArea() {
      this.formData = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.formData), {}, {
        storeId: undefined
      });
      this.fetchStore();
    },
    updateData: function updateData() {
      var _this4 = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          var data = {
            notification: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this4.formData), {}, {
              target: "CUSTOMER",
              store: null
            }),
            areaId: _this4.formData.areaId,
            storeId: _this4.formData.storeId
          };
          _this4.submitLoading = true;
          notification.update(_this4.formData.id, data).then(function (res) {
            if (res.status) {
              _this4.$message({
                type: "success",
                message: "Cập nhật thành công"
              });
              _this4.$emit("update:success");
              _this4.dialogVisible = false;
            }
          }).finally(function () {
            _this4.submitLoading = false;
          });
        }
      });
    }
  }
};